import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { PageHeadingComponent } from './page-heading.component';
import { LinkModule } from '@challenger6/vm-pattern-library/link';

@NgModule({
  declarations: [PageHeadingComponent],
  exports: [PageHeadingComponent],
  imports: [CommonModule, RouterModule, LinkModule],
})
export class PageHeadingModule {}
